export default "__VITE_ASSET__e251d045__"